module.exports = __webpack_public_path__ + "c6c8c40f6f12bc69efe60dd77522b0d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-female-4.svg
// module id = 85
// module chunks = 0